import { Search } from "lucide-react";
import { Input } from "@/shared/ui/input";

interface TagSearchInputProps {
  value: string;
  onChange: (value: string) => void;
}

export function TagSearchInput({ value, onChange }: TagSearchInputProps) {
  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-ink-400" />
      <Input
        placeholder="Search tags to add..."
        className="pl-9"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoFocus={false}
      />
    </div>
  );
}
